import styled, { css } from 'styled-components';
import { Icon } from '@/app/common/icons/Icon';

export const Container = styled.div<{ disabled?: boolean }>`
  width: 100%;
  position: relative;
  background-color: white;

  ${({ disabled }) =>
    disabled &&
    css`
      pointer-events: none;
      opacity: 0.5;
    `}
`;

export const InputWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  width: 100%;
  height: 56px;
  padding: 0 16px 0 40px;
  border-radius: 8px;
  background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  box-sizing: border-box;
  cursor: text;
  transition: border-color 0.2s ease;

  &:hover {
    border-color: ${({ theme }) => theme.kallisto.color.border.interactive.borderInteractivePrimary};
  }
`;

export const SearchIcon = styled(Icon)`
  position: absolute;
  left: 10.5px;
  top: 50%;
  transform: translateY(-50%);
  flex-shrink: 0;
  pointer-events: none;
`;

export const InputLabel = styled.label<{ hasValue: boolean; isFocused: boolean }>`
  position: absolute;
  left: 40px;
  top: 50%;
  transform: translateY(-50%);
  font-size: ${({ hasValue, isFocused }) => (hasValue || isFocused ? '11px' : '16px')};
  color: ${({ theme }) => theme.kallisto.color.text.static.textSecondary};
  pointer-events: none;
  transition:
    font-size 0.15s ease,
    top 0.15s ease;

  ${({ hasValue, isFocused }) =>
    (hasValue || isFocused) &&
    css`
      top: 10px;
      transform: none;
    `}
`;

export const StyledInput = styled.input`
  width: 100%;
  height: 20px;
  margin-top: 24px;
  border: none;
  outline: none;
  background: transparent;
  font-size: 16px;
  line-height: 20px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  padding: 0;
  cursor: text;

  &:disabled {
    cursor: not-allowed;
  }
`;

export const DropdownOverlay = styled.div`
  position: absolute;
  top: 56px;
  left: 0;
  width: 100%;
  border-radius: 8px;
  box-shadow:
    0 24px 32px rgba(0, 0, 0, 0.04),
    0 16px 24px rgba(0, 0, 0, 0.04),
    0 4px 8px rgba(0, 0, 0, 0.04),
    0 0 10px rgba(0, 0, 0, 0.04);
  max-height: 240px;
  overflow-y: auto;
  overscroll-behavior: none;
  z-index: 10;
  background-color: white;

  &::-webkit-scrollbar-track,
  &::-webkit-scrollbar {
    width: 3px;
    background-color: ${({ theme }) => theme.kallisto.color.common.black[50]};
  }

  &::-webkit-scrollbar-thumb {
    background-color: #080808;
  }
`;

export const OptionItem = styled.li<{ isSelected: boolean; isHighlighted: boolean; isDisabled: boolean }>`
  list-style: none;
  padding: 8px 16px;
  min-height: 48px;
  cursor: pointer;
  display: flex;
  align-items: center;
  font-size: 16px;
  line-height: 24px;
  color: ${({ theme }) => theme.kallisto.color.text.static.textPrimary};
  background-color: transparent;

  ${({ isHighlighted, theme }) =>
    isHighlighted &&
    css`
      background-color: ${theme.kallisto.color.background.interactive.bgInteractiveSecondary};
    `}

  ${({ isSelected, theme }) =>
    isSelected &&
    css`
      font-weight: 600;
      color: ${theme.kallisto.color.text.interactive.textInteractivePrimary};
    `}

  ${({ isDisabled }) =>
    isDisabled &&
    css`
      opacity: 0.4;
      cursor: not-allowed;
    `}

  &:hover {
    background-color: ${({ theme }) => theme.kallisto.color.background.interactive.bgInteractiveSecondary};
  }
`;

export const NoResults = styled.div`
  padding: 8px 16px;
  font-size: 14px;
  color: ${({ theme }) => theme.kallisto.color.common.semantic.error[400]};
`;
